/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemFormsVersion } from '../../models/system-forms-version';
import { SystemFormsVersionCreateNewVersion } from '../../models/system-forms-version-create-new-version';

export interface CreateSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost$Params {
  formId: string;
  setDefault?: boolean;
  org: string;
      body: SystemFormsVersionCreateNewVersion
}

export function createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost(http: HttpClient, rootUrl: string, params: CreateSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFormsVersion>> {
  const rb = new RequestBuilder(rootUrl, createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost.PATH, 'post');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.query('setDefault', params.setDefault, {});
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemFormsVersion>;
    })
  );
}

createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost.PATH = '/_internal/v2/system-forms/{formId}/versions';
